import {
  ResponseError,
  type PopupProps,
  Username as UsernamePopup
} from '@CS/components/Popups';

import API from '@/services/api';
import { useState } from 'react';

import type { ResponseErrorInfo } from '@/services/api/types';

type UsernameProps = PopupProps & {
  showErrorPopup?: boolean;
};

export const Username = ({ showErrorPopup, ...props }: UsernameProps) => {
  const [usernameError, setUsernameError] = useState<ResponseErrorInfo>();
  const cancelUsername = () => setUsernameError(undefined);

  const onSubmit = async (username: string) =>
    API.updateUser({ username }).catch(async (error: Response) => {
      showErrorPopup && setUsernameError(await API.getResponseErrorInfo(error));
      throw error;
    });

  return (
    <>
      <UsernamePopup onSubmit={onSubmit} {...props} />

      {usernameError && (
        <ResponseError info={usernameError} onClose={cancelUsername} />
      )}
    </>
  );
};
